import { jsx as _jsx } from "react/jsx-runtime";
import { useDispatch } from '../../../context/DispatchContext';
import EditableColumn from '../../../elements/EditableColumn';
export function RangeAssignmentColumn({ row, onHover, rowSpanTags, }) {
    const dispatch = useDispatch();
    function saveHandler(event) {
        dispatch({
            type: 'CHANGE_RANGE_ASSIGNMENT_LABEL',
            payload: {
                value: event.target.value,
                rangeID: row.id,
            },
        });
    }
    return (_jsx("td", { ...rowSpanTags, ...onHover, children: _jsx(EditableColumn, { value: row?.assignment || '', onSave: saveHandler, style: { padding: '0.1rem 0.4rem' } }) }));
}
